import React, { Component } from "react";

// React Router
import { withRouter } from "react-router-dom";

// Components
import Button from "components/Button";

// Styles
import "./Header.scss";
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";

// Icons
import MusicOnIcon from "../../static/img/SpeakerIcon.png";
import MusicOffIcon from "../../static/img/MuteSpeaker.png";
// import MenuIcon from "../../static/img/crossicon.svg";
//import CodeBerryLogo from "static/icons/code-berry-logo.png";
// import Progress from 'react-progressbar';
//import CircularBlackCrossIcon from 'static/icons/circular-black-cross-icon.svg'

// Sounds
import { ButtonSound, BackgroundMusicStart, BackgroundMusicStop } from "../../utility/sounds"
import { GAME_TIME } from "utility/Timer";
import './Header.scss'

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counter: 5 * 60, // 5 minutes in seconds
      remainingTime: 5 * 60
    };
  }

  startTimer() {
    this.timer = setTimeout(() => {

    }, this.state.counter * 1000);
    this.setState({ startCounter: true })
    let counter = this.state.counter
    while (counter > 0) {
      counter--;
      if (counter === 210) {
        this.props.showSkipButton()
      }
      this.setState({ counter })
    }
    if (counter === 0) {
      this.stopTimer()
    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  logoClickHandler() {
    ButtonSound()
    this.props.history.replace("/");
  }

  musicButtonClickHandler() {
    const isMusicPlaying = JSON.parse(localStorage.getItem("playMusic"))
    if (isMusicPlaying) {
      BackgroundMusicStop()
    } else {
      BackgroundMusicStart()
    }
    localStorage.setItem("playMusic", JSON.stringify(!isMusicPlaying))
  }

  render() {
    const {
      currentLevel,
      total,
      // startCounter,
      seconds,
      showSkipButton,
      skipLevel,
      isTutorial,
      isTutorialPlaying,
      tutorialBtnHandler,
    } = this.props;
    const isMusicPlaying = JSON.parse(localStorage.getItem("playMusic"))
    const getTimeString = (seconds) => {
      return `${(Math.floor(seconds / 60)).toLocaleString('en-US', {
        minimumIntegerDigits: 2
      })}:${(Math.floor(seconds % 60)).toLocaleString('en-US', {
        minimumIntegerDigits: 2
      })}`;
    }
    const getTimeProgress = (seconds) => {
      return parseInt(seconds / GAME_TIME * 100);
    }
    return (
      <div className="header">
        <div className="center-header">
          <div className="header__main-container">
            <p className="header__main-container--level-text">
              {isTutorial ? "Tutorial" : `Level ${currentLevel} of ${total}`}
            </p>
          </div>
          <div className="progress-timing">
            <p className="timer2">{getTimeString(seconds)}</p>
            <Progress
              percent={getTimeProgress(seconds)}
            />
          </div>
          <div className="header__container">
            <div className="header__actions">
              {showSkipButton ? <div className='skip' onClick={skipLevel}>Skip</div> : null}
              {tutorialBtnHandler && (
                <button className="tutorial-btn" onClick={() => {
                  tutorialBtnHandler()
                }}>

                  {isTutorial
                    ? "Skip Tutorial"
                    : isTutorialPlaying
                      ? "Close Tutorial"
                      : "Show Tutorial"}
                </button>
              )}

              <Button
                className="btn-tab btn__square header__menu-icon"
                style={{ marginLeft: "9px" }}
                onClick={() => this.musicButtonClickHandler()}
              >
                <img
                  className="sounds"
                  src={
                    isMusicPlaying
                      ? MusicOnIcon
                      : MusicOffIcon
                  }
                  alt="Music icon"
                />
              </Button>
              {/* <Button className="btn-tab btn__square header__menu-icon" onClick={() => { ButtonSound() }}>
              <img
              className="sounds sounds2"
                src={MenuIcon}
                alt="Menu icon"
              />
            </Button> */}
            </div>
          </div>


          {/* <div className="header__close-btn-container">
          <img src={CircularBlackCrossIcon} alt="Close icon" className="header__close-btn-container--image" />
        </div> */}
        </div>
      </div >
    );
  }
}
export default withRouter(Header);
